import script from "./EditReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./EditReminder.vue?vue&type=script&setup=true&lang=js"

import "./EditReminder.vue?vue&type=style&index=0&id=05a6f6f6&lang=css"

const __exports__ = script;

export default __exports__